angular.module('jv.Dashboard.My.Pending.Approvals.Controller', [])
.controller('jv.Dashboard.My.Pending.Approvals.Controller',
    ['$scope','jvDashboardAjaxService', 'jvContextualLoadingService', '$window', 'Reqs','$rootScope', 'TemplateLoader',
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window, Reqs, $rootScope, TemplateLoader){

    $scope.refreshTimestamp = true;
    $scope.expanded = {};
    $scope.isPendingJobApproval = ($scope.widgetObject.subType === 'MyPendingJobApprovals');
    $scope.isPendingOfferApproval = ($scope.widgetObject.subType === 'MyPendingOfferApprovals');
    $scope.currentPage = 0;
    $scope.pageSize = 5;
    $scope.totalCount = 0;
    $scope.modals = {
        approval: {
            show: false,
            approve: false,
            reject: false,
            notes: "",
            submitted: false,
            approveObject: {},
            maxLength: 1024
        }
    };

    var postData = {};
    var readMode = 1;

    //Handler for refresh_widget
    $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
        if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
            $scope.refreshTimestamp = false;
            $scope.getMyPendingApprovals(0);
        }
    });

    $scope.templates = TemplateLoader.register({
        approvalActions: '/admin/myaccount/dashboard/modals/approvalActions.html'
    });

    var showApprovalModal = function() {
        TemplateLoader.load('approvalActions').then(function(){
            $scope.modals.approval.show = true;
            $scope.isDisabled = false;
        });
    };

    $scope.hideModals = function() {
        $scope.modals.approval.show = false;
        $scope.modals.approval.approve = false;
        $scope.modals.approval.reject = false;
        $scope.modals.approval.notes = "";
        $scope.modals.approval.submitted = false;
    };

    var postOfferApproval = function(reject) {
        var data = {
            reject: reject,
            notes: $scope.modals.approval.notes,
            appId: $scope.modals.approval.approveObject.applicationEId
        };

        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        jvDashboardAjaxService.postOfferApproval(data, function(response) {
            $scope.hideModals();
            $scope.getMyPendingApprovals(0);
        });
    };

    var postJobApproval = function(reject) {
        var data = {
            reject: reject,
            notes: $scope.modals.approval.notes,
            j: $scope.modals.approval.approveObject.EId
        };

        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        jvDashboardAjaxService.postJobApproval(data, function(response) {
            $scope.hideModals();
            $scope.getMyPendingApprovals(0);
        });
    };

    $scope.approvalAction = function(reject) {
    	    $scope.isDisabled = true;
        if ($scope.modals.approval.approveForm.$valid === false) {
            return;
        }

        readMode = 0;
        $scope.modals.approval.submitted = true;
        
        if ($scope.isPendingJobApproval) {
            postJobApproval(reject);
        } else {
            postOfferApproval(reject);
        }
    };

    $scope.approve = function(approval) {
        $scope.modals.approval.approve = true;
        $scope.modals.approval.approveObject = approval;
        showApprovalModal();
    };

    $scope.reject = function(approval) {
        $scope.modals.approval.reject = true;
        $scope.modals.approval.approveObject = approval;
        showApprovalModal();
    };

    $scope.getMyPendingApprovals = function(pageNumber) {
        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        $scope.currentPage = pageNumber;
        if ($scope.isPendingJobApproval) {
            postData = {
                'refreshGrid': 'refresh',
                'searchAllReq': true,
                'sortBy': 'lastUpdated',
                'awaitingApproval': true,
                'page': pageNumber,
                'maxResults': $scope.pageSize,
                'order': 'desc',
                'readMode': readMode
            };
            jvDashboardAjaxService.getUserJobApprovals(postData, function(response) {
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                $scope.refreshTimestamp = true;
                if(response && response.jobs){
                    $scope.approvals = response.jobs;
                    if (typeof response.jobCount !== "undefined") {
                        $scope.totalCount = response.jobCount;
                    } else {
                        $scope.totalCount = 0;
                    }
                }else{
                    //might need to change this later
                    $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                }
            });
        } else if($scope.isPendingOfferApproval){
            postData = {
                'page': pageNumber,
                'maxResults': $scope.pageSize,
                'readMode': readMode
            };
            jvDashboardAjaxService.getMyPendingOfferApprovals(postData, function(response) {
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                $scope.refreshTimestamp = true;
                if(response && response.applicationApprovalInfo){
                    $scope.approvals = response.applicationApprovalInfo;
                    $scope.totalCount = response.count;
                }else{
                    //might need to change this later
                    $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                }
            });
        }
    };

    $scope.getMyPendingApprovals(0);
}]);